import { Plugin } from '@nuxt/types';
import isMobileView from '@root/common/utils/isMobileView';

interface EventPlugin {
  send: (type: string, customParams: Record<string, any>) => void;
}

declare module 'vue/types/vue' {
  interface Vue {
    $event: EventPlugin;
  }
}

interface cxWindow extends Window {
  cX: any;
  cxTimeout: any;
}

declare let window: cxWindow;

const event: Plugin = async (ctx, inject) => {
  window.cxTimeout = null;

  const send: EventPlugin['send'] = async (type, params) => {
    if (typeof window.cX?.sendEvent === 'undefined') {
      window.cxTimeout = setTimeout(() => {
        send(type, params);
      }, 100);

      return;
    }

    clearTimeout(window.cxTimeout);

    const isLoggedIn = ctx.store.state?.piano?.isLoggedIn;
    const { channelAccess } = ctx.store.state?.piano?.access;

    const referrer = new URL(window.location.href);

    // Remove GAA parameters from referrer URL, which exceeds item field max length in Piano.
    referrer.searchParams.delete('gaa_at');
    referrer.searchParams.delete('gaa_ts');
    referrer.searchParams.delete('gaa_n');
    referrer.searchParams.delete('gaa_sig');

    const ref = referrer.toString();

    const baseParams = {
      viewport: isMobileView() ? 'mobile' : 'desktop',
      userType: isLoggedIn && channelAccess ? 'subscriber' : isLoggedIn ? 'registered' : 'anonymous',
      ref,
    };

    window.cX.sendEvent(type, { ...params, ...baseParams }, { origin: 'lth-delfi', persistedQueryId: '60134f11dac530e2cd5c308a42f829d82289a3b8' });
  };

  inject('event', { send });
};

export default event;
